/**
 * Mega menu category preview: hovering or focusing a category link swaps the featured products
 * for that collection's. The choice sticks while the pointer moves over to the cards, and resets
 * to the default list when the panel is left. Delegated on the document so it survives the
 * header being re-rendered by the Section Rendering API.
 */

/** @param {Element} panel @param {string | undefined} key */
function showPreview(panel, key) {
  const lists = panel.querySelectorAll('[data-menu-products]');
  if (lists.length < 2) return;

  const target = (key && panel.querySelector(`[data-menu-products="${CSS.escape(key)}"]`)) || lists[0];
  for (const list of lists) list.hidden = list !== target;
}

/** @param {Event} event */
function onEnter(event) {
  if (!(event.target instanceof Element)) return;
  const link = event.target.closest('.mega-menu__link[data-menu-preview]');
  const panel = link?.closest('.mega-menu');
  if (link instanceof HTMLElement && panel) showPreview(panel, link.dataset.menuPreview);
}

document.addEventListener('pointerover', onEnter);
document.addEventListener('focusin', onEnter);

document.addEventListener('pointerout', (event) => {
  if (!(event.target instanceof Element)) return;
  const panel = event.target.closest('.mega-menu');
  const next = event.relatedTarget instanceof Node ? event.relatedTarget : null;
  if (panel && !panel.contains(next)) showPreview(panel, undefined);
});
